import paymentConfigServices from '@/api/financial/paymentConfigServices'

export default {
  fetchConfigs({ commit }, registroId) {
    return new Promise((resolve, reject) => {
      paymentConfigServices.buscarPorRegistro(registroId)
        .then(response => {
          commit('SET_LISTA_PAYMENT_CONFIGS', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  saveConfig({ dispatch }, data) {
    if (data.id) {
      return paymentConfigServices.atualizar(data.id, data)
        .then(response => {
          dispatch('fetchConfigs', data.registroId)
          return response
        })
    }
    return paymentConfigServices.inserir(data)
      .then(response => {
        dispatch('fetchConfigs', data.registroId)
        return response
      })
  },
  deleteConfig({ dispatch, state }, id) {
    return paymentConfigServices.excluir(id)
      .then(response =>
        // We need the registroId to refresh the list.
        // If we don't have it in state, we might need to pass it.
        // For now let's assume we can find it in the list before deleting or pass it.
        response)
  },
}
